import { render, staticRenderFns } from "./jxlhList.vue?vue&type=template&id=12d589e1&scoped=true&"
import script from "./jxlhList.vue?vue&type=script&lang=js&"
export * from "./jxlhList.vue?vue&type=script&lang=js&"
import style0 from "./jxlhList.vue?vue&type=style&index=0&id=12d589e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d589e1",
  null
  
)

export default component.exports